<template>
	<Modal class="certificado-modal">
		<div class="certificado-container">
			<div class="certificado-texts-container">
				<span class="certificado-text">
					{{ $t('solicitaCertificado.title') }}
				</span>
				<br />
				<br />
				<span class="certificado-text">
					{{ $t('solicitaCertificado.subtitle') }}
				</span>
			</div>
			<div class="certificado-btn-container">
				<button
					class="btn-close"
					@click="$emit('close')"
				>
					{{ $t('cancel') }}
				</button>
				<button
					class="btn-certificado"
					@click="$emit('solicitar')"
				>
					{{ $t('solicitaCertificado') }}
				</button>
			</div>
		</div>
	</Modal>
</template>

<script>
export default {
	name: 'SolicitaCertificado',
	props: {},
	data() {
		return {}
	},
	methods: {},
}
</script>
<style scoped>
.certificado-container {
	display: flex;
	width: 320px;
	padding: 16px 24px;
	flex-direction: column;
	align-items: center;
	gap: 32px;

	border-radius: var(--border-xs, 4px);
	border: 1px solid var(--grays-gray-medium, #737576);
	background: var(--neutrals-neutral-white, #fefefe);

	/* drop shadow */
	box-shadow: 2px 2px 4px 0px rgba(30, 30, 30, 0.25);
}
.certificado-modal {
	background-color: rgba(0, 0, 0, 0.4);
	position: fixed;
	height: 100vh;
	width: 100vw;
	left: 0;
	top: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 15;
}
.certificado-btn-container {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 16px;
	align-self: stretch;
}
.certificado-text {
	color: var(--neutrals-neutral-black, #272728);
	/* text-s */
	font-family: 'Open Sans';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 16px; /* 114.286% */
}
.btn-certificado {
	display: flex;
	padding: var(--spacing-xs, 4px) var(--spacing-s, 8px);
	justify-content: center;
	align-items: flex-start;
	gap: var(--spacing-s, 8px);
	border-radius: var(--border-xs, 4px);
	border: 1px solid var(--neutrals-neutral-black, #272728);
	background: var(--primary-primary, #95bb49);
}

.btn-close {
	display: flex;
	padding: var(--spacing-xs, 4px) var(--spacing-s, 8px);
	justify-content: center;
	align-items: flex-start;
	gap: var(--spacing-s, 8px);
	flex: 1 0 0;
}
</style>
